import { orderBy } from 'lodash';
import { Safra } from '../@types';
import aqilaApi from './aqila-api';

class Safras {
  private readonly endpoint = 'v2/safras';

  async list(params: { ativa?: boolean } = {}) {
    const { data } = await aqilaApi.get<Safra[]>(this.endpoint, {
      params: { all: true, ...params },
    });

    return orderBy(data, 'dataInicial', 'desc');
  }

  async find(id: string) {
    const { data } = await aqilaApi.get<Safra>(`${this.endpoint}/${id}`);

    return data;
  }
}

export default new Safras();
